import { FilterService } from 'primevue/core'
import { DateTime, Duration } from 'luxon'

export default {
  install: (_app) => {
    FilterService.register('dateEQ', (date: string, value: string) => {
      if (!value) return true
      return +DateTime.fromISO(date).startOf('day') === +DateTime.fromISO(value).startOf('day')
    })
    FilterService.register('dateNotEQ', (date: string, value: string) => {
      if (!value) return true
      return +DateTime.fromISO(date).startOf('day') !== +DateTime.fromISO(value).startOf('day')
    })
    FilterService.register('dateLT', (date: string, value: string) => {
      if (!value) return true
      return +DateTime.fromISO(date).startOf('day') > +DateTime.fromISO(value).startOf('day')
    })
    FilterService.register('dateGT', (date: string, value: string) => {
      if (!value) return true
      return +DateTime.fromISO(date).startOf('day') < +DateTime.fromISO(value).startOf('day')
    })
    FilterService.register('durationEQ', (duration, value) => {
      if (!value) return true
      return +Duration.fromISO(duration) === +Duration.fromISOTime(value)
    })
    FilterService.register('durationNotEQ', (duration, value) => {
      if (!value) return true
      return +Duration.fromISO(duration) !== +Duration.fromISOTime(value)
    })
    FilterService.register('durationGT', (duration, value) => {
      if (!value) return true
      return +Duration.fromISO(duration) > +Duration.fromISOTime(value)
    })
    FilterService.register('durationLT', (duration, value) => {
      if (!value) return true
      return +Duration.fromISO(duration) < +Duration.fromISOTime(value)
    })
    FilterService.register('timeEQ', (time, value) => {
      if (!value) return true
      return DateTime.fromISO(value).toFormat('HH:mm') === DateTime.fromISO(time).toFormat('HH:mm')
    })
    FilterService.register('timeNotEQ', (time, value) => {
      if (!value) return true
      return DateTime.fromISO(value).toFormat('HH:mm') !== DateTime.fromISO(time).toFormat('HH:mm')
    })
    FilterService.register('timeGT', (time, value) => {
      if (!value) return true
      return DateTime.fromISO(value).toFormat('HH:mm') < DateTime.fromISO(time).toFormat('HH:mm')
    })
    FilterService.register('timeLT', (time, value) => {
      if (!value) return true
      return DateTime.fromISO(value).toFormat('HH:mm') > DateTime.fromISO(time).toFormat('HH:mm')
    })
  }
}
